import jwt_decode from 'jwt-decode';
import React, { useEffect, useState, useRef } from 'react'
import dayjs, { Dayjs } from 'dayjs';

import { useDispatch, useSelector } from 'react-redux';
import { compareAsc, format } from 'date-fns'
import moment from "moment";
import Att_Helth_Status from './Att_Helth_Status';
import InOutComp from "./InOutComp"
import { get_today_in_out_time, get_weekly_punch_in_time, attendenace_action, get_HRS_Today } from '../../Redux/Actions/attendance_action';
// import Start_Time from './Start_Time';
import Modal from "react-bootstrap/Modal";
import TotalcountinoutInAday from './TotalcountinoutInAday';
import { Space, TimePicker, DatePicker, showNow } from "antd";
import Att_StatusComp from './Att_StatusComp';
import Select from 'react-select'
import MonthSummaryComp from './MonthSummaryComp';
import LoaderImage from "../../img/loader.gif"
import StatisticsComp from './StatisticsComp';
import { Line } from '@react-pdf/renderer';
import { Link } from 'react-router-dom';
import TableLoader from '../../CommanCom/TableLoader';
const user_login_id = localStorage.getItem('userId')


function UserAttendanceCom() {

    const attend_data = useSelector((state) => state.attendenace.data.attendenace_arr);
    const todayInOutTime = useSelector((state) => state.attendenace.todayInOutTime);

    const [role, setRole] = useState('')
    const [system_role, setSystem_role] = useState([]);

    const get_oermission_data = useSelector((state) => state);
    const month_total_HRS = useSelector((state) => state?.attendenace?.month_att_time);
    const week_total_HRS = useSelector((state) => state?.attendenace?.week_att_time);
    const office_hilidays = useSelector((state) => state.attendenace.data.holiday_arr);
    const hr_permission = get_oermission_data.login_Permission.permissions
    const hr_permission_arr = Array()
    if (hr_permission) {
        const hr_permission_arr1 = JSON.parse(hr_permission).split(",")
        hr_permission_arr1.map((item, ind) => {
            hr_permission_arr.push(item);
        })
    }
    const [week_workhr, setWeek_workhr] = useState();
    const [workingdays, setWorkingdays] = useState(0)
    const [month_workhr, setMonth_workhr] = useState();
    const [countWeekOf, setcountWeekOf] = useState(0);
    const [day, setDay] = useState(moment().format('D'))
    const [month, setMonth] = useState(moment().format('M'))
    const [year, setYear] = useState(moment().format('YYYY'))
    const [dayscount, setDayscount] = useState([])
    const [user_filetr, setUser_filter] = useState([])
    const [user, setUser] = useState(localStorage.getItem('userId'))
    const dispatch = useDispatch()
    let token = JSON.parse(localStorage.getItem('key'));

    let SERVER_URL = process.env.REACT_APP_API_URL;
    const userId = localStorage.getItem('userId');
    const userInformationData = jwt_decode(token.value);
    // console.log(userInformationData.systemRole,'token============::')
    const storeToken = token.value;
    const date = new Date();
    var current_date_day = moment().format('D')
    const current_date = moment(new Date()).format("YYYY-MM-DD");
    const [daysinmonth, setDaysinmonth] = useState(0)
    const [depdata, setDepdata] = useState([]);
    const [department, setDepartment] = useState('');
    const [options, setOptions] = useState([])
    const [options2, setOptions2] = useState([])
    const [options3, setOptions3] = useState([])
    const [error, setError] = useState(null);
    let countweekOfToday = 0
    for (var i = 1; i <= day; i++) {
        if (moment(new Date(year, month - 1, i)).format("ddd") == 'Sun' || moment(new Date(year, month - 1, i)).format("ddd") == 'Sat') {
            countweekOfToday += 1
        }
    }
    const [countweekofToday, setCountweekofToday] = useState(countweekOfToday)
    // setCountweekofToday(countweekOfToday)
    let count_pre = 0;
    attend_data.map((item, ind) => {

        if (ind != day) {
            const words = item?.total_hr?.split(':');
            if (parseInt(words) >= 7) {
                count_pre = count_pre + 1
                // console.log(ind + 'if =>' + item?.total_hr)
            }

        }
        // console.log(ind + '=>' + day)
    })
    const [present, setPresent] = useState(count_pre)

    useEffect(() => {
        let days = [];
        let weekoff = 0;
        const lastDayOfMonth = new Date(year, month, 0).getDate();
        setDaysinmonth(lastDayOfMonth)
        for (let i = 1; i < lastDayOfMonth + 1; i++) {
            days.push(
                moment(new Date(year, month - 1, i)).format("D")
            );

            if (moment(new Date(year, month - 1, i)).format("ddd") == 'Sun' || moment(new Date(year, month - 1, i)).format("ddd") == 'Sat') {
                setcountWeekOf(countWeekOf + 1)
                weekoff += 1
            }


        }
        setcountWeekOf(weekoff)
        setDayscount(days)
        // alert(lastDayOfMonth)
        // let number_of_days = getDaysArray(year, month)
        // setDaysinmonth(number_of_days)
        const state = {
            emp_id: user,
            date: year + '-' + month,
            storeToken: token.value,
        }
        let date_formate = format(date, 'yyyy-MM-dd')

        dispatch(get_weekly_punch_in_time(userId, token))
        dispatch(attendenace_action(state))
        // dispatch(get_today_in_out_time(user))
        // let number_of_days = getDaysArray(year, month)

    }, [role, user, month, year])

    ///////////////////// set with signal

    const controller = new AbortController();
    const signal = controller.signal; // The signal that we will pass to the fetch request

    useEffect(() => {
        const getDepartmentList = async () => {
            try {
                const response = await fetch(SERVER_URL + `api/common/department_list`,
                    {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'authorization': `bearer ${token.value}`
                        },
                        signal: signal
                    });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const result = await response.json();
                const DivisionList = result.result || [];
                if (DivisionList.length > 0) {
                    const newOptions2 = DivisionList.map((item) => ({
                        value: item.id,
                        label: item.name,
                    }));
                    setOptions2(newOptions2);
                } else {
                    setOptions2([]);
                }
            }
            catch (err) {
                if (err.name === 'AbortError') {
                    console.log('Fetch request was aborted');
                } else {
                    setError(err.message || 'An error occurred');
                }
            }
        };
        getDepartmentList();
        return () => {
            controller.abort(); // This will cancel the fetch request when the component unmounts
        };
    }, [])


    useEffect(() => {
        const getSystemRole = async () => {
            try {
                const response = await fetch(SERVER_URL + `api/common/sytem-role`,
                    {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'authorization': `bearer ${token.value}`
                        },
                        signal: signal,
                    })
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const result = await response.json()
                setSystem_role(result.result)
            } catch (err) {
                if (err.name === 'AbortError') {
                    console.log('Fetch Role request was aborted');
                } else {
                    setError(err.message || 'Role An error occurred');
                }
            }
        }
        getSystemRole()
        return () => {
            controller.abort();
        };
    }, [])

    useEffect(() => {
        const getDepartmentWishEmpList = async () => {
            try {
                const response = await fetch(SERVER_URL + `api/common/department-wish-emp-list`,
                    {
                        method: 'post',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'authorization': `bearer ${token.value}`
                        },
                        body: JSON.stringify({
                            userId: userId,
                        }),
                        signal: signal,
                    })
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const result = await response.json();
                const SelfDeptEmpList = result.result || [];
                if (SelfDeptEmpList.length > 0) {
                    const newOptions3 = SelfDeptEmpList.map((item) => ({
                        value: item.id,
                        label: item.name,
                    }));
                    setOptions3(newOptions3);
                } else {
                    setOptions3([]);
                }
            } catch (err) {
                if (err.name === 'AbortError') {
                    console.log('Fetch Role request was aborted');
                } else {
                    setError(err.message || 'Role An error occurred');
                }
            }
        }

        if (userInformationData.systemRole === 8 || userInformationData.systemRole === 3) {
            getDepartmentWishEmpList()
            return () => {
                controller.abort();
            }
        }
    }, [])
    useEffect(() => {
        setUser_filter([])
        const get_emp_list_for_filter = async (role, department) => {
            try {
                const response = await fetch(SERVER_URL + `api/employee/getEmployeeslist/user_filter?role=${role}&&dept=${department}`,
                    {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'authorization': `bearer ${token.value}`
                        },
                        signal: signal
                    })
                const result = await response.json()
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                if (result.status == true) {
                    const userList = result?.data || []
                    if (userList.length > 0) {
                        const newOptions = userList.map((item) => ({
                            value: item.user_id,
                            label: item.name,
                        }));
                        setOptions(newOptions);
                    } else {
                        setOptions([]);
                    }
                }
            } catch (err) {
                if (err.name === 'AbortError') {
                    console.log('Fetch Role request was aborted');
                } else {
                    setError(err.message || 'Role An error occurred');
                }
            }
        }
        if (department != '' && role) {
            get_emp_list_for_filter(role, department)
            return () => {
                controller.abort();
            }
        }
    }, [role, department])

    ///////////////////// set with signal

    //user_filetr


    const handleAddSelfDeptEmpOption = (SelfInputValue) => {
        const newOption3 = { value: SelfInputValue.toLowerCase(), label: SelfInputValue };
        setOptions3((prevOptions3) => [...prevOptions3, newOption3]);
        return newOption3;
    };
    const handleSelfDeptUserChange = (SelfEmpOption) => {
        setUser(SelfEmpOption ? SelfEmpOption.value : user_login_id)
    };


    const handleAddOption = (inputValue) => {
        const newOption = { value: inputValue.toLowerCase(), label: inputValue };
        setOptions((prevOptions) => [...prevOptions, newOption]);
        return newOption;
    };

    const handleAddDivisionOption = (inputValue2) => {
        const newOption2 = { value: inputValue2.toLowerCase(), label: inputValue2 };
        setOptions2((prevOptions2) => [...prevOptions2, newOption2]);
        return newOption2;
    };
    const handleUserChange = (selectedOption) => {
        setUser(selectedOption ? selectedOption.value : user_login_id)
    };
    const handleDivisionChange = (selectedOption2) => {
        setDepartment(selectedOption2 ? selectedOption2.value : '')
    };

    // const [daysinmonth, setDaysinmonth] = useState({})
    // var getDaysArray = function (year, month) {
    // alert(month)
    // var monthIndex = month-1;
    // var names = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    // var date = new Date(year, monthIndex, 1);
    // var result = {};
    // var count_sun_sat = 0;
    // var working_days_in_month = 0;
    // alert(date)
    // while (date.getMonth() == monthIndex) {
    //     result[date.getDate()] = names[date.getDay()];
    //     if (date.getDay() == 0) {
    //         count_sun_sat = count_sun_sat + 1
    //     }
    //     if (date.getDay() == 6) {
    //         count_sun_sat = count_sun_sat + 1
    //     }
    //     if (date.getDay() == 1 || date.getDay() == 2 || date.getDay() == 3 || date.getDay() == 4 || date.getDay() == 5) {
    //         working_days_in_month = working_days_in_month + 1
    //     }
    //     date.setDate(date.getDate() + 1);
    // }
    // return result;
    // }
    function calculateHourse(timeIn, timeOut, created_on, updated_on) {

        var startdate = moment(created_on).format("YYYY-MM-DD");
        var enddate = moment(updated_on).format("YYYY-MM-DD");



        const startTime1 = moment(startdate + ' ' + timeIn, "YYYY-MM-DD hh:mm:ss");
        const endTime2 = moment(enddate + ' ' + timeOut, "YYYY-MM-DD hh:mm:ss");

        // const start_time = startTime1 + ' ' + timeIn
        // const end_time = startTime2 + ' ' + timeOut

        // console.log(startdate, 'startdate=>')
        // console.log(enddate, 'enddate=>')


        // var totalHours = end_time.diff(start_time, 'hours');
        // var totalMinutes = end_time.diff(start_time, 'minutes');

        const totalHours = endTime2.diff(startTime1, 'hours');
        const totalMinutes = endTime2.diff(startTime1, 'minutes');

        // console.log('totalHours', totalHours)
        // console.log('totalMinutes', totalMinutes)

        // return false

        var clearMinutes = totalMinutes % 60;
        var minutformat = parseInt(clearMinutes) < 10 ? '0' + clearMinutes : clearMinutes;
        var totalHoursformat = parseInt(totalHours) < 10 ? '0' + totalHours : totalHours;
        return (totalHoursformat + " : " + minutformat);
    }
    const [moreinout, setMoreinout] = useState([])
    const [inoutcount_status, setInoutcount_status] = useState(false)
    const [attdate, setAttdate] = useState('')
    const [attuserId, setAttuserId] = useState('')


    const [deatilLoader, setDeatilLoader] = useState(false)
    const HandleMorepunchInTime = (att_date, userId) => {

        setAttdate(att_date)
        setAttuserId(userId)
        setDeatilLoader(true)
        let token = JSON.parse(localStorage.getItem('key'));
        const response = fetch(SERVER_URL + `api/attendance/day-in-out-total`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    empID: userId,
                    att_date: moment(att_date).format("YYYY-MM-DD"),
                }),
            }).then(res => res.json())
            .then(data => {
                setMoreinout(data?.data)
                setDeatilLoader(false)
            })
        setInoutcount_status(!inoutcount_status)
    }




    function calculateMinuts(timeIn, timeOut) {
        var startTime = moment(timeIn, 'hh:mm:ss a');
        var endTime = moment(timeOut, 'hh:mm:ss a');
        var totalHours = (endTime.diff(startTime, 'hours'));
        var totalMinutes = endTime.diff(startTime, 'minutes');
        var clearMinutes = totalMinutes;
        return clearMinutes
    }


    const RMGF = get_oermission_data.login_Permission.user_data.RMGF;
    const RMGL = get_oermission_data.login_Permission.user_data.RMGL;
    const RMG_img = get_oermission_data.login_Permission.user_data.RMG_IMG;
    const RMG_gender = get_oermission_data.login_Permission.user_data.gender;

    const Today_HRS = useSelector((state) => state?.attendenace?.Today_HRS);
    var clearMinutes = Today_HRS ? Today_HRS % 60 : '';
    var Today_Total_MINUTS = parseInt(clearMinutes) < 10 ? '0' + clearMinutes : clearMinutes;
    var Today_Total_HRS = parseInt(Today_HRS / 60) < 10 ? '0' + parseInt(Today_HRS / 60) : parseInt(Today_HRS / 60);
    const officeHolidays = Object.values(get_oermission_data.attendenace.data.holiday_arr).length

    const [requesttype, setRequesttype] = useState(2);
    const [leave_type, setLeave_type] = useState('0')
    const [errdateMSG, setErrdateMSG] = useState('');
    const [user_attendance_id, setUser_attendance_id] = useState('')
    const [savebtn, setSavebtn] = useState(true);

    const [timesheetrequest, setTimesheetrequest] = useState(false);
    const [regularizedate, setRegularizedate] = useState();
    const [workstatus, setWorkstatus] = useState();
    const defaultDateTimeIn = dayjs().hour(9).minute(0).second(0);
    const defaultDateTimeOut = dayjs().hour(18).minute(0).second(0);
    const [intime, setIntime] = useState(defaultDateTimeIn)
    const [outtime, setOuttime] = useState(defaultDateTimeOut)
    const [reason, setReason] = useState()
    const HandlRegularize = () => {
        // alert(timesheetrequest)
        setTimesheetrequest(!timesheetrequest)
        setRegularizedate('');
        setWorkstatus('');
        setIntime(defaultDateTimeIn)
        setOuttime(defaultDateTimeOut)
        setIntime_status(false)
        setReason('');
    }
    const handleClose = () => {
        setTimesheetrequest(false)
    }
    const handleRegularize = (sdsds, regdate) => {
        // alert(sdsds)
        setRegularizedate(moment(regdate).format("YYYY-MM-DD"))
        getUserTodaysAttendance(moment(regdate).format("YYYY-MM-DD"))

    }
    const [intime_status, setIntime_status] = useState(false)
    const getUserTodaysAttendance = (regdate) => {
        setIntime(defaultDateTimeIn)
        setOuttime(defaultDateTimeOut)
        const user_id = localStorage.getItem('userId')
        const response = fetch(SERVER_URL + `api/attendance/myself-attendance-list`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    EmpID: user_id,
                    FindMonth: regdate
                }),
            }).then(res => res.json())
            .then(data => {
                setUser_attendance_id('')
                if (data.data.start_time === '00:00:00' && data.data.end_time === '00:00:00') {
                    setUser_attendance_id(data.data.id)
                    setWorkstatus(data?.data.work_type)
                    setIntime(defaultDateTimeIn)
                    setOuttime(defaultDateTimeOut)
                    setIntime_status(false)
                } else if (data.data.start_time != null || data.data.start_time != undefined) {
                    setUser_attendance_id(data.data.id)
                    const time = moment(data.data.start_time, ["HH:mm"]).format("HH:mm")
                    const date = moment(data.data.att_date).format("YYYY-MM-DD")
                    const dateTime = moment(`${date} ${time}`, "YYYY-MM-DD HH:mm:ss");
                    const formattedDateTime = dateTime.format("YYYY-MM-DDTHH:mm");
                    setIntime(formattedDateTime)
                    setIntime_status(true)
                } else if (data.data.end_time != undefined && data.data.end_time != null && data.data.end_time != '00:00:00') {
                    setUser_attendance_id(data.data.id)
                    const time_out = moment(data.data.end_time, ["HH:mm"]).format("HH:mm")
                    const date_out = moment(data.data.att_date).format("YYYY-MM-DD")
                    const dateTime_end = moment(`${date_out} ${time_out}`, "YYYY-MM-DD HH:mm:ss");
                    const formattedDateTime_out = dateTime_end.format("YYYY-MM-DDTHH:mm");
                    setOuttime(formattedDateTime_out)
                }

            })
    }
    const HandleTimeOut = (time, timeString) => {
        const outtime = moment(timeString, ["h:mm A"]).format("HH:mm")
        const outdate = moment(regularizedate).format("YYYY-MM-DD")
        const outdateTime = moment(`${outdate} ${outtime}`, "YYYY-MM-DD HH:mm:ss");
        const formattedOutDateTime = outdateTime.format("YYYY-MM-DDTHH:mm");
        setOuttime(formattedOutDateTime)
    };
    const HandleTimeIn = (time, timeString) => {
        const intime = moment(timeString, ["h:mm A"]).format("HH:mm")
        const indate = moment(regularizedate).format("YYYY-MM-DD")
        const indateTime = moment(`${indate} ${intime}`, "YYYY-MM-DD HH:mm:ss");
        const formattedInDateTime = indateTime.format("YYYY-MM-DDTHH:mm");
        setIntime(formattedInDateTime)
    };

    const [msg, setMsg] = useState('');
    const [err, setErr] = useState('');
    const handleSubmit = () => {

        setErrdateMSG('')
        if (regularizedate == '' || regularizedate == null || regularizedate == undefined) {
            setErrdateMSG('Field is required');
            return false;
        } else {
            setSavebtn(false)
            const user_login_id = localStorage.getItem('userId')
            const response = fetch(SERVER_URL + `api/attendance/time-sheet-request`,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'authorization': `bearer ${token.value}`
                    },
                    body: JSON.stringify({
                        EmpID: user_login_id,
                        attId: user_attendance_id,
                        requestDate: regularizedate,
                        requestType: requesttype,
                        requestWorkType: workstatus,
                        startTime: dayjs(intime).format("HH:mm"),
                        endTime: dayjs(outtime).format("HH:mm"),
                        requestReason: reason
                    }),
                }).then(res => res.json())
                .then(data => {
                    if (data.status == true) {
                        setErr('green')
                        setMsg('Your Timesheet request added Successfully')
                        setTimeout(function () {
                            setSavebtn(true)
                            handleClose()
                            setMsg('');
                        }, 1000);

                    } else {
                        setErr('red')
                        setMsg('Something Went Wrong')
                    }
                })
        }

    }
    return (
        <div className="container-fluid">
            <>
                <Modal show={inoutcount_status} size="md" id="confirm_login">
                    <div className="modal-body">
                        <div className="decorative-shape shape-1"></div>
                        <div className="decorative-shape shape-2"></div>
                        <button type="button" onClick={e => (setInoutcount_status(!inoutcount_status))} className="float-end btn_close" data-bs-dismiss="modal" aria-label="Close">
                            <i className="icon icon-cross fw-bold"></i>
                        </button>
                        <div className="dash_white_box_ttl text-center mb20" id="exampleModalLabel">Employee Time Tracking  <sup>[ {moment(attdate).format("YYYY-MM-DD")} ]</sup></div>

                        <div className="modal_c_height negativemargin">
                            {/* {deatilLoader && <div className="loader">Loading... Please wait...</div>} */}
                            {((attuserId && attdate) && deatilLoader) ?

                                <table className='table_style_2'>
                                    <thead>
                                        <tr>
                                            <th>Start Time</th>
                                            <th>Stop Time</th>
                                            <th>Total Hours</th>
                                        </tr>
                                    </thead>
                                    <TableLoader colSpan={3} />
                                    <tbody>

                                    </tbody>
                                </table> : <TotalcountinoutInAday userId={attuserId} att_date={attdate} moreinout={moreinout} />}
                        </div>
                    </div>
                </Modal>
            </>
            <Modal show={timesheetrequest} size="md" id="confirm_login">
                <div className="modal-body">
                    <button type="button" onClick={handleClose} className="float-end btn_close" data-bs-dismiss="modal" aria-label="Close">
                        <i className="icon icon-cross"></i>
                    </button>
                    <div className="dash_white_box_ttl text-center" id="exampleModalLabel">Regularise Attendance</div>
                    <form>
                        <div className="mb-2">
                            <label className="col-form-label">Select Type :</label>
                            <select value={requesttype} className="form-select" onChange={(e) => setRequesttype(e.target.value)} id="leavetype">
                                {/* <option value="1">Leave</option> */}
                                {/* <option value="">Select Type</option> */}
                                <option selected value="2">Regularise Time Sheet</option>
                            </select>
                        </div>


                        <div className={`leave_select ${requesttype == 1 ? 'show' : 'hide'}`} style={{ display: requesttype == 1 ? '' : 'none' }}>
                            <div className="mb-2 row">
                                {/* <div className="col-md-6">
                                    <label className="col-form-label">From Date :</label>
                                    <DatePicker
                                        placeholderText='YYYY-MM-DD'
                                        value={fromdate}
                                        id="datetime-local"
                                        date={fromdate}
                                        onChange={e => { setFromdate(moment(e).format("YYYY-MM-DD")) }}
                                        className="form-control"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        maxDate={new Date(Date.now() - (3600 * 1000 * 24))}
                                        autoComplete="nope"
                                    />
                                </div> */}
                                {/* <div className="col-md-6">
                                    <label className="col-form-label">To Date :</label>
                                    <DatePicker
                                        placeholderText='YYYY-MM-DD'
                                        value={todate}
                                        id="datetime-local"
                                        date={todate}
                                        onChange={e => { setTodate(moment(e).format("YYYY-MM-DD")) }}
                                        className="form-control"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        maxDate={new Date(Date.now() - (3600 * 1000 * 24))}
                                        autoComplete="nope"
                                    />
                                </div> */}
                            </div>
                            <div className="mb-2">
                                <label className="col-form-label"> :</label>
                                <select value={leave_type} onChange={(e) => { setLeave_type(e.target.value) }} className="form-select">
                                    <option value=''>Select Type</option>
                                    <option value='1'>Earned Leave</option>
                                    <option value='2'>Casual Leave</option>
                                    <option value='3'>Sick Leave</option>
                                    <option value='4'>Leave Without Pay</option>
                                </select>
                            </div>

                        </div>
                        <div className={`timesheet_select ${requesttype == 2 ? 'show' : 'hide'}`} style={{ display: requesttype == 2 ? '' : 'none' }}>
                            <div className="mb-2">
                                <label className="col-form-label">Regularize Date : <sup className="error_mgs"> * {errdateMSG}</sup></label>
                                {/* <DatePicker
                                    
                                    placeholderText='YYYY-MM-DD'
                                    value={regularizedate}
                                    id="datetime-local"
                                    date={regularizedate}
                                    onChange={handleRegularize}
                                    className="form-control"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    maxDate={new Date(Date.now() - (3600 * 1000 * 24))}
                                    autoComplete="nope"
                                /> */}
                                <DatePicker disabledDate={d => !d || d.isAfter(new Date(Date.now() - (3600 * 1000 * 24)))} className="form-control" use12Hours onChange={handleRegularize} />
                            </div>


                            <div className="mb-2">
                                <label className="col-form-label">Work From :</label>
                                <select className="form-select" value={workstatus} onChange={(e) => { setWorkstatus(e.target.value) }}>
                                    <option value=''>Select Work From</option>
                                    <option value='1'>Work From office</option>
                                    <option value='2'>Work From Home</option>
                                </select>
                            </div>
                            <div className="mb-2 row">
                                <div className="col-md-6">
                                    <label className="col-form-label">In Time :</label>
                                    <TimePicker
                                        disabled={intime_status == true ? true : false}
                                        className="form-control"
                                        use12Hours
                                        format="hh:mm A"
                                        onChange={HandleTimeIn}
                                        showNow={false}
                                        value={dayjs(intime)}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="col-form-label">Out Time :</label>
                                    <TimePicker
                                        className="form-control"
                                        use12Hours
                                        format="hh:mm A"
                                        onChange={HandleTimeOut}
                                        showNow={false}
                                        value={dayjs(outtime)}
                                    />
                                </div>
                            </div>
                        </div>


                        <div className="mb-3">
                            <label className="col-form-label">Reason</label>
                            <textarea className="form-control" onChange={(e) => { setReason(e.target.value) }} id="reason">{reason}</textarea>
                        </div>
                    </form>
                    <div className="modalfooter">
                        <button type="button" className="btn_6 float-end ml10" onClick={handleClose} data-bs-dismiss="modal">Cancel</button>
                        <button style={{ display: savebtn ? 'block' : 'none' }} type="button" onClick={handleSubmit} className="btn_5 float-end ">Submit</button>
                        <span className="float-end mt10 mr08" style={{ color: err ? err : '' }}>{msg}</span>
                    </div>
                </div>
            </Modal>
            <button className="btn_5 float-end" onClick={HandlRegularize}  >Regularize Attendance</button>
            {/* <button className="btn_5 float-end" data-bs-toggle="modal" data-bs-target="#attendance">Time Sheet Request</button> */}
            {/* <a href="approve_timesheet.html" className="btn_5 mr10 float-end">Approve Time Sheet</a> */}
            <div className="dash_ttl">
                Attendance
            </div>
            <div className="crumbs">
                <ul id="breadcrumbs" className="breadcrumb">
                    <li>
                        <Link to="/dashboard">Dashboard</Link>
                    </li>
                    <li className="current">
                        <span>/</span>Attendance
                    </li>
                </ul>
            </div>
            <div className="row">
                <div className="col-md-5">
                    <StatisticsComp numberOfdays={day} countWeekOf={countWeekOf} userId={userId} />
                </div>
                <div className="col-md-4">
                    {MonthSummaryComp && <MonthSummaryComp userId={user} Attmonth={month} Attyear={year} />}

                    {/* <MonthSummaryComp /> */}

                </div>
                <div className="col-md-3">
                    <div className="dash_white_box2 mb20">
                        <div className="dash_white_box_ttl">Current Day Status</div>
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='time_status_wrp'>
                                    <span>In Time</span>
                                    <span> {todayInOutTime?.inTime ? moment(todayInOutTime?.inTime, ["HH:mm"]).format("hh:mm a") : '00:00'}</span>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='time_status_wrp'>
                                    <span>Out Time</span>
                                    <span>{(todayInOutTime?.outTime && todayInOutTime?.outTime != '00:00:00') ? moment(todayInOutTime?.outTime, ["HH:mm"]).format("hh:mm a") : '00:00'}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="dash_white_box2 mb20">
                        <div className="dash_white_box_ttl">Approval Flow</div>
                        <p>Here you can see who will approve your attendance related requests</p>
                        <div className="approvalflow_wrp">
                            <img src={`${SERVER_URL}userimages/${RMG_img ? RMG_img : RMG_gender == 1 ? 'm_user.png' : 'f_user.png'}`} alt="" />
                            <div className="approvalflow_ttl mb20">
                                <div>{RMGF} {RMGL}</div>
                                <div>Level : <span>Final</span> </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="dash_white_box2 mb20">
                        <div className="dash_white_box_ttl">Attendance Sheet</div>
                        <ul className="calendar_listing">
                            <li className="calendar_listing_blk"><span className="absent"></span> Absent</li>
                            <li className="calendar_listing_blk"><span className="present"></span> Present</li>
                            <li className="calendar_listing_blk"><span className="weeklyoff"></span> Weekly Off</li>
                            <li className="calendar_listing_blk"><span className="holiday"></span> Holiday</li>
                            <li className="calendar_listing_blk"><span className="leave"></span> Leave</li>
                            <li className="calendar_listing_blk"><span className="outdoor"></span> Outdoor</li>
                            <li className="calendar_listing_blk"><span className="compoff"></span> Compoff</li>
                            <li className="calendar_listing_blk"><span className="halfday"></span> Half Day Present</li>
                            <li className="calendar_listing_blk"><span className="latein"></span> Late In - Early Out</li>
                            <li className="calendar_listing_blk"><span className="workhome"></span> Work From Home </li>
                        </ul>
                        <div className="mb20 float-end d-flex">
                            <select style={{ width: "100px" }} className="form-select mr05" value={year} onChange={e => setYear(e.target.value)}>
                                <option value="">Select Year</option>
                                <option value="2022">2022</option>
                                <option value="2023">2023</option>
                                <option value="2024">2024</option>
                                <option value="2025">2025</option>
                                <option value="2026">2026</option>
                            </select>
                            <select style={{ width: "100px" }} className="form-select mr05" value={month} onChange={e => setMonth(e.target.value)}>
                                <option value="">Select Month</option>
                                <option value="1"> Jan </option>
                                <option value="2"> Feb </option>
                                <option value="3"> Mar </option>
                                <option value="4"> Apr </option>
                                <option value="5"> May </option>
                                <option value="6"> Jun </option>
                                <option value="7"> Jul </option>
                                <option value="8"> Aug </option>
                                <option value="9"> Sept </option>
                                <option value="10"> Oct </option>
                                <option value="11"> Nov </option>
                                <option value="12"> Dec </option>
                            </select>
                            {userInformationData.systemRole === 6 || userInformationData.systemRole === 2 ?
                                <>
                                    {hr_permission_arr?.includes('48') && (
                                        <select style={{ width: "180px" }} className="form-select mr05" onChange={e => setRole(e.target.value)} value={role} >
                                            <option value=" ">Select Role</option>
                                            {
                                                system_role?.map((item, ind) => (
                                                    <option key={ind} value={item.id}>{item.role}</option>
                                                ))}
                                        </select>
                                    )}


                                    {hr_permission_arr?.includes('48') && (
                                        <Select style={{ width: "180px" }} className="mr05 selectcustom_width"
                                            options={options2}
                                            onChange={handleDivisionChange}
                                            isSearchable={true}
                                            placeholder="Search Division"
                                            isClearable
                                            onCreateOption={handleAddDivisionOption}
                                            formatCreateLabel={(inputValue) => `Add \"${inputValue}\"`}
                                            isValidNewOption={(inputValue, options) =>
                                                !!inputValue && !options.some((option) => option.label === inputValue)
                                            }
                                        />
                                    )}
                                    {hr_permission_arr?.includes('48') && (
                                        <>
                                            <Select style={{ width: "180px" }} className="mr05 selectcustom_width"
                                                options={options}
                                                onChange={handleUserChange}
                                                isSearchable={true}
                                                placeholder="Search Employee"
                                                isClearable
                                                // onCreateOption={handleAddOption}
                                                // formatCreateLabel={(inputValue) => `Add \"${inputValue}\"`}
                                                // isValidNewOption={(inputValue, options) =>
                                                //     !!inputValue && !options.some((option) => option.label === inputValue)
                                                // }
                                            />
                                        </>
                                    )}
                                </>
                                : ""}
                            {
                                userInformationData.systemRole === 3 || userInformationData.systemRole === 8 ?
                                    <>
                                        <Select style={{ width: "180px" }} className="mr05 selectcustom_width"
                                            options={options3}
                                            onChange={handleSelfDeptUserChange}
                                            isSearchable={true}
                                            placeholder="Search Employee"
                                            isClearable
                                            onCreateOption={handleAddSelfDeptEmpOption}
                                            formatCreateLabel={(inputValue) => `Add \"${inputValue}\"`}
                                            isValidNewOption={(inputValue, options) =>
                                                !!inputValue && !options.some((option) => option.label === inputValue)
                                            }
                                        />
                                    </>
                                    : ""
                            }
                        </div>
                        <h2 style={{ lineHeight: "46px" }} className="mb20"> {moment(new Date(year, month - 1)).format("MMM YYYY")}</h2>
                        <table className="table_style_2">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Attendance View </th>
                                    <th>Start Time</th>
                                    <th>Stop Time</th>
                                    <th>Total Hours</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    dayscount?.map((key, ind) => (
                                        <tr key={key}>
                                            <td><i className="icon icon-calendar-full mr03"></i>
                                                {
                                                    moment(new Date(year, month - 1, key)).format("MMM DD ddd")
                                                }
                                            </td>
                                            <td>
                                                {/* {moment(attend_data[key]?.att_date).format("YYYY-MM-DD")} */}
                                                {<Att_Helth_Status
                                                    att_date={year + '-' + (month < 10 ? '0' + month : month) + '-' + key}
                                                    user_id={attend_data[key]?.user_id}
                                                    holidayName={office_hilidays[key]?.holiday_name}
                                                    leave_status={attend_data[key]?.leave_status}
                                                    daysname={key}
                                                    month={moment(new Date(year, month - 1, key)).format("MM")}
                                                    year={moment(new Date(year, month - 1, key)).format("YYYY")}
                                                    currendate={moment(new Date(year, month - 1, key)).format("DD")}
                                                    holiday_name={office_hilidays[key]?.holiday_name ? office_hilidays[key]?.holiday_name : ''}
                                                    inOut_count={attend_data[key]?.count}
                                                    start_time={attend_data[key]?.start_time} end_time={attend_data[key]?.end_time}
                                                />}
                                            </td>
                                            {/* <td><Start_Time
                                                user_id={attend_data[key]?.user_id}
                                                month={moment(new Date(year, month - 1, key)).format("MM")}
                                                year={moment(new Date(year, month - 1, key)).format("YYYY")}
                                                currendate={moment(new Date(year, month - 1, key)).format("DD")}
                                                token={token}
                                            /></td> */}
                                            <td>
                                                {attend_data[key]?.count == 1 && attend_data[key]?.start_time ? attend_data[key]?.start_time != '00:00:00' ? <i className="icon icon-clock"></i> : '' : ''}
                                                {attend_data[key]?.count == 1 && attend_data[key]?.start_time != '00:00:00' ? attend_data[key]?.start_time ? moment(attend_data[key]?.start_time, 'HH:mm').format('hh:mm a').toUpperCase() : '' : ''}
                                                {attend_data[key]?.count > 1 && <InOutComp att_date={attend_data[key]?.att_date} leave_status={attend_data[key]?.leave_status} user_id={attend_data[key]?.user_id} count={attend_data[key]?.count} att_id={attend_data[key]?.id} status_check='2' start_time={attend_data[key]?.start_time} end_time={attend_data[key]?.end_time} />}
                                            </td>
                                            <td>
                                                {attend_data[key]?.count > 1 && <InOutComp att_date={attend_data[key]?.att_date} leave_status={attend_data[key]?.leave_status} user_id={attend_data[key]?.user_id} count={attend_data[key]?.count} att_id={attend_data[key]?.id} status_check='3' start_time={attend_data[key]?.start_time} end_time={attend_data[key]?.end_time} />}
                                                {attend_data[key]?.count == 1 && attend_data[key]?.end_time ? attend_data[key]?.end_time != '00:00:00' ? <i className="icon icon-clock"></i> : '' : ''}
                                                {attend_data[key]?.count == 1 && attend_data[key]?.end_time != '00:00:00' ? attend_data[key]?.end_time ? moment(attend_data[key]?.end_time, 'HH:mm').format('hh:mm a').toUpperCase() : '' : attend_data[key]?.status == 0 ? '--' : ''}

                                            </td>
                                            <td>

                                                {attend_data[key]?.count > 1 && <InOutComp att_date={attend_data[key]?.att_date} leave_status={attend_data[key]?.leave_status} user_id={attend_data[key]?.user_id} count={attend_data[key]?.count} att_id={attend_data[key]?.id} status_check='1' start_time={attend_data[key]?.start_time} end_time={attend_data[key]?.end_time} />}
                                                {/* {attend_data[key]?.end_time != '00:00:00' ? attend_data[key]?.end_time ? <i className="icon icon-clock"></i> : '' : ''} */}
                                                {/* {attend_data[key]?.end_time != '00:00:00' ? attend_data[key]?.end_time ? calculateHourse(attend_data[key]?.start_time, attend_data[key]?.end_time) + ' HRS' : '' : attend_data[key].status == 0 ? '00:00 HRS' : ''} */}

                                                {(attend_data[key]?.count == 1 && attend_data[key]?.end_time != '00:00:00') && <i className="icon icon-clock"></i>}

                                                {(attend_data[key]?.count == 1 && attend_data[key]?.end_time != '00:00:00') && calculateHourse(attend_data[key]?.start_time, attend_data[key]?.end_time, attend_data[key]?.created_on, attend_data[key]?.updated_on) + ' HRS'}


                                                <span>  {attend_data[key]?.count > 1 && attend_data[key]?.leave_status === 0 ? <i onClick={e => HandleMorepunchInTime(attend_data[key]?.att_date, attend_data[key]?.user_id)} style={{ fontSize: '11px', color: '#38b406' }} className="fa fa-info-circle hand ml05 fa-hourglass-start"></i> : ''}</span>
                                            </td>

                                            <td>
                                                {office_hilidays[key]?.day ?
                                                    attend_data[key]?.end_time ? '' : <div className="table_btn holiday1">{office_hilidays[key]?.holiday_name}</div> : moment(new Date(year, month - 1, key)).format("ddd") == 'Sun' ? <div className="table_btn weeklyoff1">Weekly Off</div> : moment(new Date(year, month - 1, key)).format("ddd") == 'Sat' ? <div className="table_btn weeklyoff1">Weekly Off</div> : attend_data[key]?.start_time ? '' : parseInt(key) > parseInt(current_date_day) ? '' : ''}
                                                <Att_StatusComp user_id={attend_data[key]?.user_id} inOut_count={attend_data[key]?.count} start_time={attend_data[key]?.start_time} end_time={attend_data[key]?.end_time} att_date={attend_data[key]?.att_date}
                                                    holiday_name={office_hilidays[key]?.holiday_name}
                                                    leave_status={attend_data[key]?.leave_status}
                                                    daysname={key}
                                                    month={moment(new Date(year, month - 1, key)).format("MM")}
                                                    year={moment(new Date(year, month - 1, key)).format("YYYY")}
                                                />
                                                {/* {attend_data[key]?.count == 1 && (calculateMinuts(attend_data[key]?.start_time, attend_data[key]?.end_time) < 540 && calculateMinuts(attend_data[key]?.start_time, attend_data[key]?.end_time) > 270) ? <div className="table_btn halfday1">Halfday</div> : ''}
                                                {attend_data[key]?.count == 1 && calculateMinuts(attend_data[key]?.start_time, attend_data[key]?.end_time) >= 540 ? <div className="table_btn present1">Present</div> : ''}
                                                {attend_data[key]?.count == 1 && (current_date == moment(attend_data[key]?.att_date).format("YYYY-MM-DD")) && ''}
                                                {attend_data[key]?.count > 1 && <InOutComp att_date={attend_data[key]?.att_date} user_id={attend_data[key]?.user_id} count={attend_data[key]?.count} att_id={attend_data[key]?.id} status_check='5' start_time={attend_data[key]?.start_time} end_time={attend_data[key]?.end_time} />}
                                                // {office_hilidays[key]?.day ? attend_data[key]?.end_time ? '' : <div className="table_btn holiday1">{office_hilidays[key]?.holiday_name}</div> : moment(new Date(year, month - 1, key)).format("ddd") == 'Sun' ? <div className="table_btn weeklyoff1">Weekly Off</div> : moment(new Date(year, month - 1, key)).format("ddd") == 'Sat' ? <div className="table_btn weeklyoff1">Weekly Off</div> : attend_data[key]?.start_time ? '' : parseInt(key) > parseInt(current_date_day) ? '' : <div className="table_btn absent1">Absent</div>}
                                            */}
                                            </td>
                                            {/* <td>
                                                {
                                                    (moment(new Date(year, month - 1, key)).format("ddd") == 'Sun' || moment(new Date(year, month - 1, key)).format("ddd") == 'Sat') && <div className="table_btn weeklyoff1">Weekly Off</div>
                                                }
                                            </td> */}
                                        </tr>
                                    ))
                                }

                            </tbody>
                        </table>
                    </div>

                </div>

            </div>

        </div>
    )
}
export default UserAttendanceCom